// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CcZeroIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from cc-zero.svg
 */
export default function CcZeroIcon(props: CcZeroIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CcZeroIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.983 0c2.238 0 4.148.78 5.72 2.342a7.7 7.7 0 0 1 1.715 2.582c.39.962.582 1.99.582 3.076a8.1 8.1 0 0 1-.583 3.087 7.3 7.3 0 0 1-1.703 2.526 8.2 8.2 0 0 1-2.655 1.77Q9.572 16 7.983 16a7.9 7.9 0 0 1-3.042-.6 8.3 8.3 0 0 1-2.6-1.759A8.1 8.1 0 0 1 .6 11.042 7.8 7.8 0 0 1 0 8q0-1.585.6-3.042a8.1 8.1 0 0 1 1.77-2.633C3.893.772 5.764 0 7.983 0m.034 1.44Q5.272 1.44 3.4 3.355a7 7 0 0 0-1.457 2.157 6.387 6.387 0 0 0 0 4.969 6.83 6.83 0 0 0 3.585 3.558q1.186.486 2.488.487a6.4 6.4 0 0 0 2.482-.498 6.9 6.9 0 0 0 2.185-1.446C13.93 11.364 14.56 9.839 14.56 8a6.6 6.6 0 0 0-.487-2.515 6.4 6.4 0 0 0-1.418-2.118Q10.73 1.439 8.017 1.44M11.305 8c0-2.113-.664-4.605-3.305-4.605-2.495 0-3.226 2.223-3.3 4.25L4.695 8c0 2.113.665 4.605 3.306 4.605S11.305 10.113 11.305 8M9.316 6.622 7.35 10.017c-.274.412-.083.645.219.774l.135.044q.137.033.297.034c1.358 0 1.422-1.938 1.422-2.869l-.007-.409a7 7 0 0 0-.06-.72zM6.58 7.778c.015-.985.163-2.646 1.421-2.646.107 0 .205.016.297.039.19.164.283.39.1.705L6.64 9.11l-.027-.244A10 10 0 0 1 6.577 8z"
        />
      </g>
    </svg>
  );
}
